import type { DateField } from "@/types/template";
import { focusNextTabbable } from "@/components/filler/fields/fieldUtils";

interface Props {
  field: DateField;
  value: string;
  onChange: (value: unknown) => void;
  onBlur?: () => void;
}

export function DateInput({ field, onBlur, onChange, value }: Readonly<Props>) {
  const current = value || field.defaultValue || "";

  return (
    <input
      type="date"
      value={current}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      onBlur={onBlur}
      onKeyDown={(e) => {
        if (e.key === "Tab" && !e.shiftKey) {
          e.preventDefault();
          focusNextTabbable(e.currentTarget);
        }
      }}
    />
  );
}
